export const JS_LOAD_START = ':load-start';
export const JS_LOAD_END = ':load-end';
